namespace TabAurous.Retail {
    export interface GiftVoucherItemDetailsForm {
        TransItemId: Serenity.StringEditor;
        UniqueNo: Serenity.StringEditor;
        GiftMasterId: Serenity.LookupEditor;
        Value: Serenity.DecimalEditor;
        MinInvoiceValue: Serenity.DecimalEditor;
        Expiry: Serenity.DateEditor;
        IsRedeemed: Serenity.BooleanEditor;
        IsPartial: Serenity.BooleanEditor;
        RedeemedValue: Serenity.DecimalEditor;
    }

    export class GiftVoucherItemDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.GiftVoucherItemDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!GiftVoucherItemDetailsForm.init)  {
                GiftVoucherItemDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.DateEditor;
                var w4 = s.BooleanEditor;

                Q.initFormType(GiftVoucherItemDetailsForm, [
                    'TransItemId', w0,
                    'UniqueNo', w0,
                    'GiftMasterId', w1,
                    'Value', w2,
                    'MinInvoiceValue', w2,
                    'Expiry', w3,
                    'IsRedeemed', w4,
                    'IsPartial', w4,
                    'RedeemedValue', w2
                ]);
            }
        }
    }
}
